import { Vector3 as c } from "three";
const m = (l, y = new c(), h = !1) => {
  const o = new c().fromArray(l.size), x = new c().fromArray(l.anchor).clone().multiply(o).negate(), s = [
    [y.x + x.x, y.y + x.y]
  ];
  return h ? s.push(
    [y.x + x.x + o.x, y.y + x.y],
    [y.x + x.x + o.x, y.y + x.y + o.y],
    [y.x + x.x, y.y + x.y + o.y]
  ) : s.push(
    [y.x + x.x, y.y + x.y + o.y],
    [y.x + x.x + o.x, y.y + x.y + o.y],
    [y.x + x.x + o.x, y.y + x.y]
  ), s.push([y.x + x.x, y.y + x.y]), s;
};
export {
  m as createPolygon
};
//# sourceMappingURL=index3.js.map
